import "./Footer.css";
//import Button from "@material-ui/core/Button";
// import {AccessAlarmIcon,ThreeDRotation} from '@material-ui/icons';
import FollowUs from "./FollowUs";
const Footer = function (props) {    
    let engFooterLang = props.lang==='en';
    
    return (        
        <React.Fragment>
            <div className="footerLogoDiv">
                <img className="footerLogo" src={props.data.MODFooterLogo_Url} data-holder-rendered="true"  alt="לוגו המוזיאון"/>
            </div>

            <img className="footerLine hidden-md-down"  src="/_layouts/15/images/sites/Museums/Master/Line7.png" data-holder-rendered="true"  alt="מפריד"/>
            <div className="footerContactInfoDiv">
                <div className={props.sitesNotUnit?"footerContactInfoDivIn":"footerContactInfoDivIn footerContactInfoDivInTablet"}>
                    <div className="addressFooterText">
                        <span className="footerText" dangerouslySetInnerHTML={{__html: props.data.ModFooterAddress}}></span>
                    </div>
                    <div className="phoneContactInfo">
                        <span className="footerText">{engFooterLang?"Tel: ":"טלפונים: "} </span>
                        <span className="hidden-md-down footerText">{props.data.MODPhone1}</span>
                        {props.data.MODPhone2&&<span className="hidden-md-down footerText">, </span>}
                        {/* <br/> */}
                        <span className="hidden-md-down footerText">{props.data.MODPhone2}</span>
                        <span className="hidden-lg-up footerText"><a href={"tel:"+props.data.MODPhone1} title={props.data.MODPhone1}>{props.data.MODPhone1}</a></span>
                        {props.data.MODPhone2&&<span className="hidden-lg-up footerText">,</span>}
                        <span className="hidden-lg-up footerText"><a  href={"tel:"+props.data.MODPhone2} title={props.data.MODPhone2}>{props.data.MODPhone2}</a></span>
                    </div>
                    <div className="emailContactInfo">
                        <span className="footerText">{engFooterLang?"E-mail: " : 'דוא"ל: ' } </span>
                        <br className="hidden-md-down"/>
                        <a href={"mailto:"+props.data.MODSiteMail} title={props.data.MODSiteMail}>{props.data.MODSiteMail}</a>
                    </div>
                    {(props.sitesNotUnit) && // this is for SITES and NOT for UNIT on desktop
                        <div className="hidden-md-down" > 
                            <FollowUs data={props.data} engFooterLang={engFooterLang} sitesNotUnit={props.sitesNotUnit}/>
                        </div>}
                        {/* {(props.data.ModOpeningHours) && // this is for SITES and NOT for UNIT on desktop
                        <div className="hidden-md-down" > 
                            <FollowUs data={props.data} engFooterLang={engFooterLang} sitesNotUnit={props.sitesNotUnit}/>
                        </div>} */}
                </div>
                {(!(props.sitesNotUnit)) && // this is for UNIT and NOT for SITES on mobile
                     <div className="followUsTabletIcons hidden-lg-up"> 
                        <FollowUs data={props.data} engFooterLang={engFooterLang} sitesNotUnit={props.sitesNotUnit}/>
                    </div>}
            </div>
            

            {/* {(!(props.data.ModOpeningHours)) && // this is for UNIT and NOT for SITES on desktop
                <React.Fragment>
                        <img className="footerLine hidden-md-down"  src="/_layouts/15/images/sites/Museums/Master/Line7.png" data-holder-rendered="true"  alt="מפריד"/> 
                        <div className="hidden-md-down" > 
                        <FollowUs data={props.data} engFooterLang={engFooterLang} sitesNotUnit={props.sitesNotUnit}/>
                    </div>
                </React.Fragment>
            } */}
            {(!(props.sitesNotUnit)) && // this is for UNIT and NOT for SITES on desktop
                <React.Fragment>
                        <img className="footerLine hidden-md-down"  src="/_layouts/15/images/sites/Museums/Master/Line7.png" data-holder-rendered="true"  alt="מפריד"/> 
                        <div className="hidden-md-down" > 
                        <FollowUs data={props.data} engFooterLang={engFooterLang} sitesNotUnit={props.sitesNotUnit}/>
                    </div>
                </React.Fragment>
            }

            {(props.data.ModOpeningHours) &&
                <React.Fragment>
                    <img className="footerLine hidden-md-down"  src="/_layouts/15/images/sites/Museums/Master/Line7.png" data-holder-rendered="true"  alt="מפריד"/> 
                    <div className="footerVisitAndToursDiv">
                        <span className="footerText">{engFooterLang?"Visit hours:":"ימים ושעות הביקור:"}</span>
                        <br/>
                        <span className="footerText" dangerouslySetInnerHTML={{__html: props.data.ModOpeningHours}}></span>
                        <span className="footerText">{engFooterLang? "Coordinating Tours:": "לתיאום סיורים:"}</span>
                        <br/>
                        <span className="hidden-md-down footerText">{props.data.MODTourPhone}</span>
                        <span className="hidden-lg-up footerText"><a  className="footerText" href={"tel:"+props.data.MODTourPhone} title={props.data.MODTourPhone}>{props.data.MODTourPhone}</a></span>
                    </div>
                </React.Fragment>}
            {(props.data.ModTourCosts) &&
                    <React.Fragment>
                        <img className="footerLine hidden-md-down"  src="/_layouts/15/images/sites/Museums/Master/Line7.png" data-holder-rendered="true"  alt="מפריד"/>
                        <div className="footerTicketsInfoDiv"> 
                            <div className="footerTicketInfoText">
                                <span className="footerText" dangerouslySetInnerHTML={{__html: props.data.ModTourCosts}}></span>
                            </div>
                            
                        </div>

                    </React.Fragment>
                }
                {(props.sitesNotUnit) &&   // this is for SITES and NOT for UNIT on mobile
                            <div className="ticketsAndFollowTablet">
                            
                                <div className="ticketsLink">
                                {(props.data.MODTicketsLink_Url) &&<a className="siteText" href={props.data.MODTicketsLink_Url} title={props.data.MODTicketsLink_Description}>
                                        <span className="siteText ticketsButtonText">מחירון כרטיסים</span>
                                    </a>}

                                </div>
                                <div className="followUsTabletIcons hidden-lg-up">
                                    <FollowUs data={props.data} engFooterLang={engFooterLang} sitesNotUnit={props.sitesNotUnit}/>
                                </div>
                            </div>
                }
                 {(props.sitesNotUnit) && <img className="footerLine hidden-md-down"  src="/_layouts/15/images/sites/Museums/Master/Line7.png" data-holder-rendered="true"  alt="מפריד"/> }
            
         </React.Fragment>
    );
}
export default Footer;




// new update i can need to check from row 78
// {!(props.sitesNotUnit) && 
//     <div className="followUsTabletIcons hidden-lg-up">
//     <img className="footerLogo" src={props.data.MODFooterLogo_Url} data-holder-rendered="true"  alt="לוגו המוזיאון"/>
//     <FollowUs data={props.data} engFooterLang={engFooterLang} sitesNotUnit={props.sitesNotUnit}/>
// </div>}


// {(!(props.sitesNotUnit)) && 
//     <div className="followUsTabletIcons hidden-lg-up">
//         <FollowUs data={props.data} engFooterLang={engFooterLang} sitesNotUnit={props.sitesNotUnit}/>
//     </div>}